module.exports = __webpack_public_path__ + "static/media/JAVA_API.ecda23bc.png";